// removed by extract-text-webpack-plugin
module.exports = {"Container":"notification__Container__1jVsu","Bell":"notification__Bell__Bq6ic","Count":"notification__Count__JML0H"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Notification/notification.css
// module id = 878
// module chunks = 2